<div class="content-account-settings animate">
    <div class="block-settings">
        <div class="block-settings__content">
            <div class="blocks-settings__form">
                <div class="block-settings__input">
                    <label class="block-settings__label text-sm">{{ 'words.interface-language' | translate }}</label>
                    <ng-container *ngIf="selectData.interfaceLanguages.length">
                        <msc-common-select [data]="selectData.interfaceLanguages">
                            <ng-template #buttonTemplate let-data="data">
                                <button class="flex items-center text-sm">
                                    <ng-container *ngIf="data?.length">
                                        <img class="mr-2 w-6" src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                        <span>{{ data[0].label }}</span>
                                    </ng-container>
                                </button>
                            </ng-template>
                            <ng-template #optionTemplate let-datum="datum">
                                <button class="flex items-center text-sm py-2 w-full" (click)="onSelectOption(datum)">
                                    <img class="mr-2 w-6" src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                                    <span>{{ datum.label }}</span>
                                </button>
                            </ng-template>
                        </msc-common-select>
                    </ng-container>
                </div>

                <div class="block-settings__input">
                    <label class="block-settings__label text-sm">{{ 'words.learning-languages' | translate }}</label>
                    <ng-container *ngIf="selectData.contentLanguages.length; else selectLoader">
                        <msc-common-select [data]="selectData.contentLanguages" type="multi" hasSearch="true">
                            <ng-template #buttonTemplate let-data="data">
                                <button class="flex text-sm w-full">
                                    <ng-container *ngIf="data?.length; else emptyTemplate">
                                        <span class="truncate">{{ contentLanguagesSelectedLabel }}</span>
                                    </ng-container>
                                    <ng-template #emptyTemplate>
                                        <span>{{'words.languages' | translate}}</span>
                                    </ng-template>
                                </button>
                            </ng-template>
                            <ng-template #optionTemplate let-datum="datum">
                                <label class="flex items-center justify-between text-sm py-2 w-full">
                                    <span>{{ datum.label }}</span>
                                    <msc-common2-checkbox [value]="datum.isSelected" (changeEvent)="onSelectMultiOption(datum)"></msc-common2-checkbox>
                                </label>
                            </ng-template>
                        </msc-common-select>
                    </ng-container>
                    <ng-template #selectLoader>
                        <msc-common-spinner></msc-common-spinner>
                    </ng-template>
                </div>
            </div>

        </div>
    </div>
</div>
